// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperTopbar_root__tgs2y"};